import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-payment-cancelled-modal',
	templateUrl: './payment-cancelled-modal.component.html',
	styleUrls: ['payment-cancelled-modal.component.scss'],
})
export class PaymentCancelledModalComponent {
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController): Promise<boolean> {
		const modal = await modalCtrl.create({
			component: PaymentCancelledModalComponent,
			cssClass: 'payment-cancelled-modal',
		});

		await modal.present();
		const { data } = await modal.onWillDismiss();
		return data;
	}

	dismiss(retry: boolean) {
		this.modalCtrl.dismiss(retry);
	}
}
